export const PUZZLE_METADATA_STATUS = Object.freeze({
  IDLE: "idle",
  LOADING: "loading",
  READY: "ready",
  ERROR: "error",
});

export const isPuzzleMetadataReadyForAutoplay = ({
  isPuzzleRequested,
  activePuzzleId,
  metadataPuzzleId,
  metadataStatus,
}) => {
  if (!isPuzzleRequested) return true;

  const normalizedActivePuzzleId = String(activePuzzleId || "").trim();
  const normalizedMetadataPuzzleId = String(metadataPuzzleId || "").trim();

  return (
    metadataStatus === PUZZLE_METADATA_STATUS.READY &&
    Boolean(normalizedActivePuzzleId) &&
    normalizedMetadataPuzzleId === normalizedActivePuzzleId
  );
};
